
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Component, EventEmitter, inject, Input, input, OnChanges, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TedDomain } from '../structure-data.models';import { EntryService } from '../entry.service';
import { GoogleAnalyticsService } from 'src/app/google-analytics.service';
;

// type DataToTable;

export interface Filter {
  types: string[];
  description: string;
}
export type TableNames = 'Domains';


@Component({
  selector: 'interactive-left-table',
  templateUrl: './interactive-left-table.component.html',
  styleUrl: './interactive-left-table.component.css',
  standalone: false
})
export class InteractiveLeftTableComponent implements OnChanges {

  public tedDomainData = input.required<any[]>();

  @Output()
  handleSelectedCard:EventEmitter<Object> = new EventEmitter();

  public readonly tabName = input.required<TableNames>();

  public tableData?: any;
  public currentTableFilter: string[] = [];

  public selectedRowCard = signal<any>({});
  public filters = signal<Filter[]>([]);
  public selectedFilter = signal<Filter>({} as Filter);
  public rowCards = signal<any[]>([]);
  public startNumber = signal<number>(1);
  private mappedTableRows = signal<any[]>([]);
  public uniqueTedDomains = signal<any[]>([])

  public entryService = inject(EntryService);
  constructor( public gaService: GoogleAnalyticsService) {
    this.entryService.activeDomain.subscribe((data:any)=>{
     const activeDomain = this.uniqueTedDomains().find(domain=>domain.tedNumber === data.tedNumber);
     this.selectedRowCard.set(activeDomain);
    })
  }

  async ngOnChanges(): Promise<void> {
    this.selectedRowCard.set(this.tedDomainData()[0]);
    this.uniqueTedDomains.set([]);

    const seenTedNumbers = new Set<number>();

    for (const item of this.tedDomainData()) {
      if (!seenTedNumbers.has(item.tedNumber)) {
        this.uniqueTedDomains().push(item);
        seenTedNumbers.add(item.tedNumber);
      }
    }
  }

  onCardClick(card: any): void {
    this.selectedRowCard.set(card);
    this.handleSelectedCard.emit(card);
  }
}
